<div class="e-card">
  <div class="e-card-content">
    <div class="row">
      <div class="col-3">
        <div class="row">
          <div class="col-12 mb-1">
            <ejs-dropdownlist [dataSource]="dropDownSourceFields()" (change)="onSourceFieldDropDownChange($event)" [value]="selectedDropDownSourceField()"></ejs-dropdownlist>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <ejs-grid #fieldsGrid
                      width="100%"
                      rowHeight="38"
                      [dataSource]="clientSourceFieldsReplacementData()"
                      [allowSorting]="false"
                      [allowPaging]="false"
                      (rowSelected)="onFieldSelected($event)"
                      [selectionSettings]="fieldGridSelectionOptions"
                      (commandClick)="fieldGridCommandClicked($event)"
                      (actionComplete)="onFieldGridActionComplete($event)">
              <e-columns>
                <e-column field="sourceField"
                          headerText="{{'i18n.domain.export-configuration.field-value-replacements.field-grid.title' | translate}}"
                          clipMode="EllipsisWithTooltip">
                </e-column>
                <e-column headerText="" [commands]='fieldsGridCommands' width='60px'></e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
      </div>
      <div class="col-9">
        @if (selectedField() !== null) {
          <app-field-value-replacement-list-editor [fieldValueReplacements]="fieldValueReplacementsForSource()"
                                                  (sourceValueDeleted)="onSourceValueDeleted($event)"
                                                  (linesCreated)="onLinesCreated($event)"
                                                  (sourceValueChanged)="onSourceValueChanged($event)"
                                                  (replacementValueChanged)="onReplacementValueChanged($event)">
          </app-field-value-replacement-list-editor>
        }
      </div>
    </div>
  </div>
  <div class="e-card-actions">
    <div class="d-flex">
      <div class="btn-group me-auto">
        <ejs-tooltip [content]="'i18n.domain.export-configuration.field-value-replacements.delete-button-tooltip'| translate">
          <button type="button" class="btn btn-outline-danger me-2 btn-fixedw rounded"  [disabled]="!selectedGridClient()"
            (click)="deleteFieldValueReplacementsForClient()">
            <span class="e-icons icon-erase danger me-2"></span>
            {{ 'i18n.domain.export-configuration.field-value-replacements.button-delete' | translate }}
          </button>
        </ejs-tooltip>
      </div>
      <div class="btn-group ms-auto">
        <button type="reset" (click)="discardChanges()" class="btn btn-outline-secondary me-2 btn-fixedw rounded">
          {{ 'i18n.domain.export-configuration.shared.buttons.discard' | translate }}
        </button>
        <button type="submit" (click)="onSave()" class="btn btn-outline-primary btn-fixedw rounded">
          {{ 'i18n.domain.export-configuration.shared.buttons.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
